module.exports = __webpack_public_path__ + "static/media/DSC01890.5e2e8594.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/DSC01890.jpg
// module id = 483
// module chunks = 0